<template>
  <div class="w-full bg-[#01508c] flex">
    <img src="./assets/logo.png" alt="TIM" class="mx-auto h-full" />
  </div>
  <Survey />
</template>

<script>
import Survey from "./components/Survey.vue";

export default {
  name: "App",
  components: {
    Survey,
  },
};
</script>
